import * as c from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowRightIcon } from 'src/assets/icons/nav/arrow-right.icon'
import { ChevronDownIcon } from 'src/components/navbar/icons/chevron-down-icon'

import { NavbarConfigItem } from './navbar-item.config'

interface NavbarProps {
  item: NavbarConfigItem
}

const LandingPageItem = ({ item }: NavbarProps) => {
  const { onToggle, isOpen, onOpen } = c.useDisclosure()
  const { t } = useTranslation('components/nav')

  return (
    <>
      {item.options ? (
        <c.Menu
          variant="navbar"
          placement="bottom-end"
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onToggle}
        >
          <c.MenuButton
            as={c.Button}
            maxHeight="30px"
            py="s1"
            px="s2"
            bg="none"
            _active={{
              border: '1px solid',
              bg: 'black.0',
              borderColor: 'primary.500',
            }}
            _hover={{
              bg: 'black.100',
            }}
            rightIcon={
              <c.Icon
                as={ChevronDownIcon}
                color="black.500"
                w="1rem"
                h="1rem"
              />
            }
          >
            <c.Text fontSize="t-sm.1" fontWeight="medium" color="black.500">
              {item?.title}
            </c.Text>
          </c.MenuButton>

          <c.MenuList w="min-content">
            {item.options.map((subItem) => (
              <React.Fragment key={subItem.id}>
                <c.MenuItem as={c.Link} href={subItem.path} isExternal>
                  <c.Icon
                    as={subItem.Icon}
                    w="1.25rem"
                    h="1.25rem"
                    color="black.400"
                  />
                  {subItem.label}
                  <c.Icon
                    as={ArrowRightIcon}
                    color="black.300"
                    w="1.25rem"
                    h="1.25rem"
                    ml="auto"
                  />
                </c.MenuItem>

                {subItem.id === 'housi-atendimento' && (
                  <c.Text
                    fontSize="xs"
                    bg="rgb(210, 212, 215)"
                    mb="s2"
                    p="s3"
                    borderRadius="12px"
                  >
                    {t('components/nav:INVESTORS-PERSONA.finalText')}
                  </c.Text>
                )}
              </React.Fragment>
            ))}
          </c.MenuList>
        </c.Menu>
      ) : (
        <c.Link
          target="_blank"
          href={item?.path as string}
          style={{ textDecoration: 'none', display: 'flex' }}
        >
          <c.Button
            maxHeight="30px"
            py="s1"
            px="s2"
            bg="none"
            _hover={{ bg: 'black.100' }}
            fontSize="t-sm.1"
            fontWeight="medium"
            color="black.500"
          >
            {item.title}
          </c.Button>
        </c.Link>
      )}
      <c.Divider orientation="vertical" height="20px" mx="s1" />
    </>
  )
}
export default LandingPageItem
